export type ChangeOrderFilters = {
    status: 'accepted' | 'rejected' | 'pending' | 'inProcess' | null;
    reportedById: number | null;
    reportedOn: Date | null;
    searchWorkItem: string | null;
    page: number;
    surveyId: number | null;
}

export type ChangeOrderComponent = {
    id: number;
    surveyId: number;
    hasAttachment: boolean;
    componentName: string;
    originalValue: number;
    proposedValue: number;
    uom: string;
}

export type ChangeOrder = {
    id: number;
    surveyInfo: SurveyChangeOrderInfo | null;
    manualInfo: ManualChangeOrderInfo | null;
    reportedById: number | null;
    reportedBy: string;
    reportedAt: Date;
    finalizedAt: Date | null;
    lastStatus: string;
    source: 'Survey' | 'Manual';
}

export type SurveyChangeOrderInfo = {
    changeOrderComponents: ChangeOrderComponent[];
    surveyId: number | null;
    inspectionComment: string | null;
    workItemPath: string;
    workItemId: number;
}

export type ManualChangeOrderInfo = {
    changeOrderId: number;
    scheduleImpact: number;
    scheduleImpactUnit: 'days' | 'hours';
    laborCost: number;
    materialCost: number;
    equipmentCost: number;
    subContractorCost: number;
    workItems: {
        id: number;
        path: string;
    }[];
    description: string;
}

export type PaginatedChangeOrders = {
    changeOrders: ChangeOrder[];
    allCount: number;
}

export interface ChangeOrderEvent {
    eventId : number
    changeOrderId : number
    status: string
    notes: string
    createdAt: Date
    performedById: number
    performedBy: string
}

export const statusOptions: Record<string, string> = {
	Approved: 'Approved',
	Rejected: 'Rejected',
	Pending: 'Pending',
	InProcess: 'In Process',
}

export type ManualChangeOrder = {
    hasCostImpact: boolean;
    hasScheduleImpact: boolean;
    scheduleImpact: number;
    scheduleImpactUnit: 'days' | 'hours';
    laborCost: number;
    materialCost: number;
    equipmentCost: number;
    subContractorCost: number;
    workItemIds: number[];
    description: string;
}